export const translationUploadData_en_part2 = {
  scheduledFor: "Scheduled for",
  chunkDisabled: "Disabled",
  chunkPartiallyDisabled: "Partially disabled",
  chunkEnable: "Enable chunk",
  chunkDisable: "Disable chunk",
  chunkEnabledLabel: "Active in knowledge base",
  chunkEnabledHint: "Disabled chunks stay in the list but are not retrieved by bots.",
  chunkEnabledMessage: "Chunk enabled",
  chunkDisabledMessage: "Chunk disabled",
  chunkStatusUpdateError: "Could not update chunk status",
  chunkScheduleSection: "Visibility schedule",
  chunkScheduleHint:
    "Optional schedule for when this chunk should be active in the knowledge base (e.g. 17:00–07:00).",
  chunkSchedulePill: "Scheduled visibility",
  chunkScheduleNone: "Always active",
  chunkScheduleFixed: "Between dates",
  chunkScheduleWeekly: "Weekly hours",
  bannerScheduleNone: "Always (no schedule)",
  bannerScheduleFixed: "Between dates",
  bannerScheduleWeekly: "Weekly hours",
  bannerScheduleStarts: "Start (optional)",
  bannerScheduleEnds: "End (optional)",
  bannerScheduleTz: "Timezone",
  bannerScheduleWeeklyDays: "Days",
  bannerScheduleWeeklyStart: "Start time",
  bannerScheduleWeeklyEnd: "End time",
  bannerScheduleWeeklyHint:
    "If end time is earlier on the clock than start time, the window crosses midnight (e.g. 17:00–07:00).",
  bannerScheduleFixedHint: "Stored as absolute times. Clear a field to leave it open-ended.",
  bannerScheduleEndIn3Days: "End in 3 days",
  bannerWeekday0: "Sun",
  bannerWeekday1: "Mon",
  bannerWeekday2: "Tue",
  bannerWeekday3: "Wed",
  bannerWeekday4: "Thu",
  bannerWeekday5: "Fri",
  bannerWeekday6: "Sat",
  // Missing Info Tickets
  // Missing Info Tickets
  missingInfoTickets: "Missing Info",
  missingInfoTicketsTitle: "Missing Information Tickets",
  missingInfoTicketsDescription: "AI-powered suggestions for content to upload to your chatbot",
  generateTickets: "Generate Tickets",
  generating: "Generating...",
  selectLanguageOption: "Select language",
  selectTicketTranslationLanguage: "Select language for ticket translation",
  translateTickets: "Translate",
  translatingTickets: "Translating...",
  analyzingConversations: "Analyzing conversations and generating tickets...",
  generatedTickets: "Generated {count} new tickets!",
  noNewTicketsGenerated: "No new tickets generated",
  howItWorks: "How it works:",
  howItWorksDescription:
    'Every Monday, the AI automatically analyzes your recent conversations tagged with "missing info" and creates tickets for the most common questions. You can also manually trigger ticket generation anytime.',
  pending: "Pending",
  uploaded: "Uploaded",
  rejected: "Rejected",
  expired: "Expired",
  noChatbotSelected: "No chatbot selected",
  selectChatbotMessage: "Please select a chatbot from the dropdown above to view tickets.",
  noTicketsFound: "No tickets found",
  generateTicketsPrompt: "Generate tickets to get AI-powered suggestions for missing information",
  noTicketsWithStatus: "No tickets with this status",
  priority: "Priority",
  deleteTicket: "Delete ticket",
  uploadInfo: "Upload Info",
  reject: "Reject",
  uploadInformation: "Upload Information",
  titleLabel: "Title",
  titlePlaceholder: "Title for this information",
  informationLabel: "Information",
  informationPlaceholder: "Enter the information that answers this question...",
  questionLabel: "Question:",
  autoDeleteOptional: "Auto-delete (optional)",
  selectAutoDeleteDate: "Select date and time",
  clearDate: "Clear date",
  autoDeleteTooltip: "Content will be automatically deleted at the selected time",
  selectIndexFirst: "Please select a knowledge base first",
  ticketRejected: "Ticket rejected",
  ticketDeleted: "Ticket deleted",
  infoUploadedSuccess: "Information uploaded successfully!",
  uploadSuccessSummaryLabel: "Summary",
  uploadSuccessOk: "OK",
  enterInfoToUpload: "Please enter the information to upload",
  failedToFetchTickets: "Failed to fetch tickets",
  failedToGenerateTickets: "Failed to generate tickets",
  failedToRejectTicket: "Failed to reject ticket",
  failedToDeleteTicket: "Failed to delete ticket",
  failedToTranslateTickets: "Failed to translate tickets",
  failedToUploadInfo: "Failed to upload information",
  basedOnConversations: "Based on {count} conversation(s)",
  viewConversation: "View conversation",
  relatedConversations: "Related conversations",
  noRelatedConversations: "No related conversations",
  more: "more",
  // AI Help translations
  // AI Help translations
  aiHelp: "AI Help",
  aiHelpComingSoon: "AI Help functionality coming soon!",
  aiHelpDescription: 'Click "Run Analysis" to get AI-powered insights about your info chunks',
  aiAnalysis: "AI Analysis",
  runAnalysis: "Run Analysis",
  analyzing: "Analyzing...",
  analyzingYourData: "Analyzing your data...",
  potentialDuplicates: "Potential Duplicates",
  recommendations: "Recommendations",
  totalItems: "Total Items",
  duplicates: "Duplicates",
  backToUpload: "Back to Upload Data",
  markAsHandled: "Mark as handled",
  markAsNotHandled: "Mark as not handled",
  showHandled: "Show handled",
  searchPlaceholder: "Search your info chunks...",
  resultsFound: "results found",
  clearHighlightedItems: "Clear Highlighted Items",
  showMore: "Show more",
  showLess: "Show less",
  confidence: "Confidence",
  show: "Show",
  loading: "Loading...",
  suggestMerge: "Suggest Merge",
  mergeSuggestion: "Merge Suggestion",
};
